import { useEffect, useState } from "react";

import { listDraftVersions } from "@/api/drafts-v2";

import { generatedLine, latestGeneration } from "./provenance";

const VERSION_PAGE = 50;

/**
 * "Generated Nov 2, 2026 by Casey" for an open draft, or null while loading,
 * when nothing generated it, or when it has no document yet. `refreshKey`
 * refetches (a run landing a new generation).
 */
export const useDraftProvenance = (
  draftId: string,
  hasDocument: boolean,
  refreshKey?: unknown
): string | null => {
  const [line, setLine] = useState<string | null>(null);
  useEffect(() => {
    if (!hasDocument) {
      setLine(null);
      return undefined;
    }
    let live = true;
    listDraftVersions(draftId, { limit: VERSION_PAGE })
      .then((versions) => {
        if (!live) return;
        const generation = latestGeneration(versions ?? []);
        setLine(generation ? generatedLine(generation) : null);
      })
      .catch(() => {
        if (live) setLine(null);
      });
    return () => {
      live = false;
    };
  }, [draftId, hasDocument, refreshKey]);
  return line;
};
